import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import JsZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver';
import PageTracker from '../../../../common/PageTrackerHelper'


export default {
  name: 'ChangeShipmentDetails',
  components: {
      VueElementLoading,
      Paginate,
      JsZip
  },
  mixins:[PageTracker],
  data: function() {
      return {
       ChangeIN:'',
       OrderType:'',
       ServiceType:'',
       NetPayment:'',
       ChangeINList:['Service Type','Order Type','Net Payment'],
       OrderTypeList:['COD','Prepaid'],
       ServiceTypeList:['XBDelivery','SDD','NDD','SDD/NDD','LH','QSR','SFC'],
       comments:'',
       max : '',
       change:null,
       commentFlag:null,
       Loading: false,
       localuserid:'',
       localusermailid:'',
       rolename:'',
       OutSourcingMasterId:'',
       Status:'0',
       ShippingID:'',
       shipmentData:[],
       checkCount: null,
       isLoading:false,
       ReturnMessage:'',
       oldServiceType:'',
       oldOrderType:'',
       oldNetPayment:'',
      }
  },
  created: function() {},
  async mounted(){
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail',userdetail);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubname = userdetail.hubdetails[0];
    this.OutSourcingMasterId = userdetail.outsourcingid;

    let TrackerInfo = {
        projectname:"Last Mile",
        type:"Web",
        userid:this.localuserid,
        username:this.localusermailid,

        meta: {
            "event":""
        }
    }
    let result  = this.PageTracker(TrackerInfo);
  },
  methods : {
    // changeDateFormat(inputString){
    //   let current_datetime = new Date(inputString)
    //   let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
    //   return formatted_date;
    // },
    update(searchdata){
       searchdata.ShippingID = this.ShippingID
       searchdata.LastModifiedBy = this.localusermailid

       let search = {
        "ShippingID": "1111921182248",
        "ServiceType": "SD",
        "OrderType": "Prepaid",
        "NetPayment": "500",
        "Comments": "ordertype and servicetype updation",
        "UpdateType": "NetPayment",
        "LastModifiedBy": "xyz"
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'external/updateordertypeandnetpaymentforlastmile',
          'data': searchdata
      })
      .then(async result => {

        if(result.data.code == 200){
        this.$alertify.success(result.data.message);
        this.getShipmentdetailsbyshippingid()
        this.commentFlag =null
        this.OrderType=''
        this.ServiceType=''
        this.NetPayment=''
        this.comments=''
        this.ChangeIN=''
        }else{
        this.$alertify.error(result.data.message);
        }

      })
    },
    async updateShipmentDetails(scope){
      this.$validator.validateAll(scope).then(result => {
        let serchData = {}
         let selectedChangeIN = ($("#ChangeIN option:selected").text()).replace(" ","").trim();

        if(this.comments){
          if((this.comments).length > 500){
            this.$alertify.error("Enter Comment upto 500 Characters");
          }else{
            if(selectedChangeIN == 'ServiceType'){
              if(!this.ServiceType){
                this.$alertify.error("Please Select Service Type");
              }else{
               let cmt = 'Shipment Service Type updated from ' + this.oldServiceType + ' to ' +this.ServiceType + ': ' + this.comments

                serchData ={
                  Comments:cmt,
                  ServiceType:this.ServiceType,
                  OrderType: this.oldOrderType,
                  NetPayment: this.oldNetPayment,
                  UpdateType: "ServiceType",
                }
                 this.update(serchData)
              }
            }else if (selectedChangeIN == 'OrderType') {
              if(!this.OrderType){
                this.$alertify.error("Please Select Order Type");
              }else if(this.oldNetPayment == 0 || this.oldNetPayment == null){
                this.$alertify.error("Cannot change order type. Net Payment is zero");
              }
              else {
                //let selectedOrderType = (($("#OrderType option:selected").text()).replace(" ","").trim()).replace(" ","").toLowerCase();
                let cmt = 'Shipment OrderType updated from ' + this.oldOrderType + ' to ' + this.OrderType + ': ' + this.comments
                serchData ={
                  Comments:this.comments,
                  OrderType:this.OrderType,//selectedOrderType,
                  ServiceType:this.oldServiceType,
                  NetPayment: this.oldNetPayment,
                  UpdateType: "OrderType",
                }
                 this.update(serchData)
              }
            }else {
              if(!this.NetPayment){
                this.$alertify.error("Please Enter Net Payment");
              }else {

                if((this.oldOrderType).toLowerCase() == "cashondelivery" || (this.oldOrderType).toLowerCase() == "cod"){
                   if(parseFloat(this.NetPayment) > 199999.00){
                     this.$alertify.error("Invalid ! Net Payment Cannot Be Greater Than Rs.199999.");
                   }else {
                     let cmt = '(NetPayment changed '+ parseFloat(this.oldNetPayment) + ' to ' + parseFloat(this.NetPayment) + '): ' +this.comments

                     serchData ={
                       Comments:cmt,
                       NetPayment:this.NetPayment,
                       ServiceType:this.oldServiceType,
                       OrderType: this.oldOrderType,
                       UpdateType: "NetPayment",
                     }

                      this.update(serchData)
                   }
                }else {
                  let cmt = '(NetPayment changed '+ parseFloat(this.oldNetPayment) + ' to ' + parseFloat(this.NetPayment) + '): ' +this.comments

                  serchData ={
                    Comments:cmt,
                    NetPayment:parseFloat(this.NetPayment),
                    ServiceType:this.oldServiceType,
                    OrderType: this.oldOrderType,
                    UpdateType: "NetPayment",
                  }
                   this.update(serchData)
                }
              }
            }
          }

        }
      })

    },
    setChangeIN(e){
      this.change = null
      this.commentFlag =null
      this.OrderType=''
      this.ServiceType=''
      this.NetPayment=''
      this.comments=''
       let selectedChangeIN = ($("#ChangeIN option:selected").text()).replace(" ","").trim();
       if(selectedChangeIN == 'ServiceType'){
         this.change = '0'
         this.commentFlag ='1'
       }else if (selectedChangeIN == 'OrderType') {
        this.change = '1'
        this.commentFlag ='1'
       }else {
        this.change = '2'
        this.commentFlag ='1'
       }
    },
    getShipmentdetailsbyshippingid(){
     this.$validator.validateAll().then(result => {
       this.change = null
       this.commentFlag =null
       this.OrderType=''
       this.ServiceType=''
       this.NetPayment=''
       this.comments=''
       this.ChangeIN = ''
       if(this.ShippingID){

         let serchData = {
            "ShippingID":[(this.ShippingID).trim()],
            "HubID" : (this.hubname).toString().trim()//212
          }
          this.ReturnMessage = ''
          this.shipmentData = []
          this.isLoading = true;
          this.oldServiceType = ''
          this.oldOrderType = ''
          this.oldNetPayment = ''
          this.checkCount = null
          this.ReturnMessage = ''
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'external/getOrderDetailsforLastMile',
              'data': serchData
          })
          .then(async result => {

            if(result.data.code == 200){
               this.checkCount ='1'
               this.shipmentData = result.data.data[0]
               this.oldServiceType = this.shipmentData.ServiceType
               this.oldOrderType = this.shipmentData.OrderType
               this.oldNetPayment = this.shipmentData.CollectibleAmount
               this.isLoading = false;
            }else{
                this.checkCount ='2'
                this.ReturnMessage = result.data.message
                this.shipmentData = []
                this.isLoading = false;
            }

          })
       }
     })
    },
    reset(){
    this.ShippingID =''
    this.checkCount = null
    this.ReturnMessage = ''
    this.shipmentData = {}
    this.isLoading = false;
    this.change = null
    this.commentFlag =null
    this.OrderType=''
    this.ServiceType=''
    this.NetPayment=''
    this.comments=''
    }

  }
}

Validator.extend('verify_shipments', {
  getMessage: field => "Invalid ShippingId. Please Enter valid shippingID",
  validate: value => {
      var ShippingID = $("#ShippingID").val();
      let flag=0;
      if(isNaN(ShippingID) || (ShippingID.length<3)){
        flag=1;
      }
      if(flag==1){
        return false;
      }else{
        return true;
      }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/ChangeShipmentDetails/ChangeShipmentDetails/ChangeShipmentDetails.component.js